module.exports = __webpack_public_path__ + "static/media/SR.ba3c45c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/SR.svg
// module id = 2265
// module chunks = 7